<template>
  <div class="main-content-container contact-info-container">
    <div class="top-content-container normalize-zIndex position-relative">
      <b-row>
        <b-col class="position-relative breadcrumbs-column" md="6" cols="12">
          <b-breadcrumb>
            <b-breadcrumb-item>
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span
                v-if="paFullname.length > 0"
                class="text-uppercase font-family-medium"
              >
                {{ paFullname }}
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>

        <b-col
          v-if="!showSkeletonLoader"
          md="12"
          cols="12"
          class="pa-avatar-column d-none d-md-flex d-lg-flex d-xl-flex justify-content-end position-relative"
        >
          <div class="user-info-right d-flex mr-4">
            <b-avatar
              size="8rem"
              v-if="userAvatar"
              :src="userAvatar"
            ></b-avatar>
            <b-avatar
              size="8rem"
              v-else
              :text="userInitials"
              class="bg--primary"
            ></b-avatar>
            <div class="user-info-content">
              <p class="font-family-medium primary--text pa-name">
                {{ paFullname }}
              </p>
            </div>
          </div>
        </b-col>
        <b-col
          v-else
          md="12"
          cols="12"
          class="pa-avatar-column skeleton-column d-none d-md-flex d-lg-flex d-xl-flex justify-content-end position-relative"
        >
          <div class="user-info-right d-flex">
            <b-skeleton type="avatar" size="8rem"></b-skeleton>
          </div>
          <div
            class="user-info-content d-flex flex-column justify-content-center position-relative"
          >
            <b-skeleton width="14rem"></b-skeleton>
            <b-skeleton width="14rem" class="mt-3"></b-skeleton>
          </div>
        </b-col>

        <b-col class="d-xl-none d-md-none d-lg-none" md="12" cols="12">
          <div class="user-info-right d-flex justify-content-start">
            <b-avatar
              size="8rem"
              v-if="userAvatar"
              :src="userAvatar"
            ></b-avatar>
            <b-avatar
              size="8rem"
              v-else
              :text="userInitials"
              class="bg--primary"
            ></b-avatar>
            <div
              class="user-info-content d-flex flex-column position-relative"
              :class="[role === 'assistant' ? 'justify-content-center' : null]"
            >
              <h4 class="font-md font-family-medium primary--text">
                {{ paFullname }}
              </h4>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-tabs
      v-model="tabIndex"
      @input="setActiveTab"
      v-if="!isLoadingTabs"
      class="mt-4"
      style="height:85%"
      active-nav-item-class="danger"
      active-tab-class="text-success"
    >
      <b-tab
        style="height:100%"
        title="Tasks"
        v-if="role === 'admin' || isSelf"
      >
        <PATasks v-if="tabIndex == 0" />
      </b-tab>
      <!-- <b-tab title="Professional Goals" v-if="role === 'admin' || isSelf">
        <PAProfessionalGoals />
      </b-tab> -->
      <b-tab title="Contacts">
        <AdminContactInfo :tab="tabIndex" :isSelf="isSelf" />
      </b-tab>
      <b-tab title="Customers" class="mb-5" v-if="role === 'admin' || isSelf">
        <PACustomers
          :isSelf="isSelf"
          :customersList="customersList"
          :isLoadingCustomers="isLoadingCustomers"
          v-if="tabIndex === 3"
        />
      </b-tab>
    </b-tabs>
    <!-- <b-avatar
      v-if="role === 'admin' && tabIndex === 3"
      button
      @click="$router.push({ name: 'AddCustomer' })"
      size="4.8rem"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar> -->
  </div>
</template>

<script>
import PATasks from "../common/assistant/tasks/PATasks";
// import PAProfessionalGoals from "../common/assistant/professional/PAProfessionalGoals";
import PACustomers from "../common/assistant/customers/PACustomers";
import AdminContactInfo from "@/views/admin/AdminContactInfo";
import { getProfile } from "@/apis/auth";
import { getAdminsDetails } from "@/apis/assistants";
import { getAdminCustomers } from "@/apis/customers";
import { internalCustomerEmailSet } from "@/utils/constants";

export default {
  name: "AdminDetails",
  components: {
    PATasks,
    // PAProfessionalGoals,
    PACustomers,
    AdminContactInfo
  },
  data() {
    return {
      workHours: "",
      isLoadingTabs: true,
      isLoadingCustomers: true,
      showSkeletonLoader: true,
      tabIndex: null,
      userAvatar: null,
      userInitials: "",
      isSelf: null,
      paFullname: "",
      role: "",
      resetForm: false,
      customersList: []
    };
  },
  methods: {
    setActiveTab() {
      this.$router.push({
        params: {
          uuid: this.$route.params.uuid
        },
        name: "AdminDetails",
        query: {
          tab: this.tabIndex
        }
      });
      this.resetForm = true;
    }
  },
  created() {
    const { tab } = this.$route.query;
    this.tabIndex = Number(tab);
    getProfile()
      .then(res => {
        this.role = res.data.role;
        if (this.$route.params.uuid === res.data.defaultProfile.id) {
          this.isSelf = true;
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.isLoadingTabs = false;
      });
    getAdminsDetails(this.$route.params.uuid)
      .then(res => {
        let { user } = res.data;
        this.paFullname = `${user.firstName} ${user.lastName} `;
        this.userAvatar = user.avatarThumbnail;
        this.userInitials = this.paFullname.match(/\b(\w)/g).join("");
        getAdminCustomers(res.data.id)
          .then(res => {
            this.customersList = [...res.data.results]
              .filter(
                el =>
                  !internalCustomerEmailSet.has(el.customer.profile.user.email)
              )
              .map(item => {
                let { firstName, lastName, email } = item.customer.profile.user;
                item.customerEmail = email;
                item.customerFullname = `${firstName} ${lastName} `;
                item.customerInitials = item.customerFullname
                  .match(/\b(\w)/g)
                  .join("");
                return item;
              });
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingCustomers = false;
          });
      })
      .catch(err => {
        console.log(err);
        this.showSkeletonLoader = false;
      })
      .finally(() => {
        this.showSkeletonLoader = false;
      });
  },
  watch: {
    $route(to) {
      if (to.query && to.query.tab) {
        this.tabIndex = Number(to.query.tab);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.floating-action-btn {
  right: 3rem;
  bottom: 0;
  z-index: 2;
}
.skeleton-column {
  margin-left: -2rem;
}
.user-info-right {
  right: 0;
  top: -10%;
  right: 2%;
}
.user-info-content {
  flex-direction: column;
  display: flex;
  padding-left: 10px;
  > p {
    flex: 1;
    margin-bottom: 0;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  > p:only-child.pa-name {
    align-items: center;
  }
  > p:nth-child(1) {
    align-items: flex-end;
  }
  > p:nth-child(2) {
    align-items: flex-start;
  }
}
.general-info-card {
  padding: 1rem;
}
.breadcrumbs-column {
  z-index: 1000;
}
.pa-avatar-column {
  margin-bottom: -5rem;
  bottom: 3rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
</style>
